import { getSpeciesUrl } from '../../helpers/urls';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { Container } from '../Container/Container';
import { Heading } from '../Heading/Heading';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';

import { IStateDataObjectSpecies } from './helpers/buildStateDataSpecies';

interface IProps {
  stateName: string | null;
  stateDataSpecies: IStateDataObjectSpecies[];
}

export const USStateTopSpecies = ({ stateName, stateDataSpecies }: IProps) => {
  const title = `Top species caught in ${stateName ? stateName : 'this state'}`;
  return (
    <Container className="pt-sm" data-testid="USStateTopSpecies">
      <Heading as="h3" variant="md" className="mb-6">
        {title}
      </Heading>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:grid-cols-4">
        {stateDataSpecies.map(species => (
          <InternalLink
            key={species.fish_external_id}
            className="bg-lake-fog flex w-full items-center justify-between rounded-lg p-3"
            to={getSpeciesUrl(species.fish_external_id, species.common_name)}
            data-testid="USStateTopSpecies-species"
          >
            {species.common_name}
            <ArrowRightIcon />
          </InternalLink>
        ))}
      </div>
    </Container>
  );
};
